
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkIfLoggedIn } from '../../store/actions/authenticationActions'
import queryString from 'query-string';
import { CircularProgress } from '@material-ui/core';

import { getUserInfo } from '../../store/actions/accountActions'

export default function (ComposedComponent) {
    //console.log("Inside HOC");


    class Authentication extends Component {
        state = {
            loading: true
        }
        componentDidMount() {
            console.log(this.props.isLoginTokenValid)

            if (!this.props.isLoginTokenValid) {

                // Entry from banner / quickActions
                try {
                    this.props.checkIfLoggedIn((account) => {
                        // Make the other calls ! 
                        this.setState({
                            loading: false
                        })


                    });
                } catch (err) {
                    this.setState({
                        loading: false
                    })
                }

            } else {
                this.setState({
                    loading: false
                })
            }


        }


        render() {

            return !this.state.loading ? <ComposedComponent {...this.props} /> : <CircularProgress></CircularProgress>

        }
    }

    const mapStateToProps = (state) => {
        return {
            isLoginTokenValid: state.authentication.isLoginTokenValid,
            currentUser: state.authentication.currentUser
        };
    }
    const mapDispatchToProps = (dispatch) => {

        return {
            checkIfLoggedIn: (token) => dispatch(checkIfLoggedIn(token)),
            getUserInfo: (userId, cb) => dispatch(getUserInfo(userId, cb)),
        }

    }
    return connect(mapStateToProps, mapDispatchToProps)(Authentication);
}
